import React from "react";
import { useEffect, useState } from "react";
import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useParams, useLocation, useNavigate } from "react-router-dom";

import CustomizedAccordions from "../../components/homepage/accordion";
import ContentCards from "../../components/homepage/contentCards";
import CustomContainer from "../../components/layout/container";
import CustomHeader from "../../components/layout/header";

import BaowuLogo from "../../images/Baowu_Steel_logo.webp";
import BaowuTraining from "../../images/business-training-cartoon.jpg"

import FeedbackFaces from "../../images/FeedbackFaces_Red.jpg"

const BaowuSteelCaseStudy = () => {
  // const router = useNavigate();
  // const { BaowuSteel } = useParams();

  const [pageTitle, setPageTitle] = useState("");
  const [borderColorToHighlight, setborderColorToHighlight] =
    useState("why/case-study/BaowuSteel");

  const breadcrumbData = [
    { name: "Home", link: "/" },
    {
      name: `Case Study (BaowuSteel)`,
      link: `/why/case-study/BaowuSteel`,
    },
  ];

  return (
    <Box>
      <Grid>
        <title>{pageTitle?.toUpperCase()} | MEF</title>
        <meta
          name="description"
          content="Identify & Quantify Macroeconomic/Esg risk"
        />
      </Grid>
      <CustomHeader
        title={"Client Case Study-Consultancy"}
        breadcrumbData={breadcrumbData}
      />

      <CustomContainer>
        <Box >
          <Grid container spacing={1.5}>
            <Grid item xs={12} sm={6} md={4}>
              <ContentCards
                imgSrc={BaowuLogo}
                title="Client Profile - Global Steel Company"
                objectFit="contain"
                subTitle="Supplying Green Energy Infrastructure & Grid build-out"
                //example to link in text
                body={`Baowu Steel Group are an international Steel company based in Shandong, China; 
                    they produce 1 million tons of steel annually. Thier products are exported to more than 80 countries and regions. Its mission
                    is to be a leader in Global steel industry, and to jointly build a high-quality iron & steel ecosphere. It has a registered 
                    capital of US $100 million, and specializes in the production and sales of steel products. `}
              />
              <CustomizedAccordions
                title="Baowu Steel Group's Service philosophy"
                body={`Baowu Steel Group adhere to the service concept of equality and mutual benefit, and are committed to providing the best economical solutions for valued customers:
              <ul>
                <li><strong>Efficient Communication</strong></li>
                <li><strong>Research & Innovation</strong></li>
                <li><strong>Sufficient Inventory</strong></li>
                <li><strong>Product Packaging</strong></li>
                <li><strong>Timely Customer Service</strong></li>
              </ul>
              `}
              />
              <CustomizedAccordions
                title="Baowu Steel's Needs"
                body={`Whilst providing much of the Global stell required to facilitate the ongoing (Green) Energy transformation, Baowu Steel are also a massive user of Energy
                and also face various, forthcoming (European) Green regulations eg <a title="Carbon Border Adjustment Mechanism">CBAM</a> "green border tax". As such, for effective strategic management its
                essential that their management team are fully aware of the latest trends/projections in both the outlook for the Global economy (and thus Energy Demand) <i>and</i> cost developments
                in (Green) Energy supply. Both of these Global factors will directly impact their core operation & profitability/CAPEX in the medium term.
                `}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <ContentCards
                imgSrc={BaowuTraining}
                title="Client Needs-Bespoke Management Training"
                objectFit="contain"
                subTitle={`Why BaowuSteel use MEF services - Global Economy/Energy Trends; Risk Scanning/Mitigation Training`}
                body={`<p> 
                    Following initial consultation & research, MEF was commissioned to collaboratively design a custom management training that focused on some 
                    of the many significant risks & uncertainties facing this large, Global, exporter to 2030 and beyond.
                    MEF rapidly designed & delivered, specialist management training/CPD units, delivered over several years in conjunction with the AMBS China program. 
                    These examined trends in both (EU) Green Regulation eg <a title="Carbon Border Adjustment Mechanism">CBAM</a> impacting high-emission sectors like Steel, as well as different scenarios for the 
                    evolution of both Energy Demand (and thus Electricity grid expansion & build-out globally) and the <a title="Levelised Cost of Electricity">LCOE</a> for various different renewable Electricity
                    Generation technologies. </p>`}
              />
              <CustomizedAccordions
                title="Transition to Green Steel"
                body={`The evolution of Global trends in Energy Demand and Cost of Supply - alongside ongoing technology breakthroughs & wildcards  - will significantly impact the timelines of the transition of 
                    Global steel producers towards the production of Green Steel. But forward-thinking management need to be aware of current, likley outcomes
                    <i>today</i> in order to stay vigilant as the Energy transformation/disruption unfolds Globally. `}
              />
              {/* <CustomizedAccordions
                title="Risk awareness in Risk Mitigation"
                body={`TEXT HERE `}
              /> */}
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <ContentCards
                imgSrc={FeedbackFaces}
                title="Client Feedback"
                objectFit="contain"
                subTitle={`On MEF Foresight & Management Training Programs - Baowu Steel Group`}
                body={`According to the Head of the China program at AMBS<i>"MEF provide the essential framing - both historically and looking forward - for the likely 
                    Global Economic, Trade & Energy environment within which the Senior management at Baowu will need to contend. This provides the essential context within
                    which the rest of the senior management training program then sits. As such, its a crucial contribution to the overall program"</i><br><br>
                <hr style="color:#00a0a0;height:1px;width:50%;">
                If you would like to initiate an informal chat about how MEF's modelling and/or scenario services may augment your risk analysis, please email us
                at: <b style="color:#00a0a0" > bespoke@mef-uk.com </b> `}
              />
            </Grid>
          </Grid>
        </Box>
      </CustomContainer>
    </Box>
  );
};

export default BaowuSteelCaseStudy;
